<template>
  <div class="tab-container">
    <div class="bg-white paddT80">
      <div class="level-1">
        <p>广州翼然科技股份有限公司</p>
        <p></p>
        <p>广州翼然科技股份有限公司（简称“翼然科技”，英文简称“YIRAN TECH”）【股权代码：880178】注册成立于2014年，座落于海珠区琶洲人工智能产业基地园区，是一家集数据、软件、服务于一体的行业顶尖的数字文旅全产业链综合服务提供商。</p>
        <p>公司专注于“全域智慧旅游/数字公园”文旅业态融合服务平台应用开发及运营、互联网＋智慧景区、文旅融合大数据应用、一部手机游APP/小程序/公众号、旅游大数据平台、3D智能导游系统、VR全景虚拟游系统、三维GIS综合管控一体化平台、电子售检票系统/商城分销系统、实名制分时段预约系统、电子触摸屏系统、客流量/车流辆实时统计分析系统、游客集散中心/游客服务中心/旅游驿站/全息投影科普展厅、全域全景旅游导览地图绘制、景区手绘地图绘制、3D导览地图制作、AI/VR/人工智能技术应用及配套物联网智能设备建设等服务，并向客户提供从数据采集、地图绘制、软件开发、系统集成、内容策划制作、项目实施，到后期维护保障的全方位服务和一体化整体解决方案。</p>
        <img src="../../assets/images/about-us/fazhang.png"></img>
      </div>
      <div class="level-2">
        <img src="../../assets/images/about-us/level-2-1.png"
             alt="">
        <img src="../../assets/images/about-us/level-2-2.png"
             alt="">
      </div>
      <div class="level-3 ">
        <div>
          <img src="../../assets/images/about-us/level-3-1.png"
               alt="">
          <img src="../../assets/images/about-us/level-3-2.png"
               alt="">
          <img src="../../assets/images/about-us/level-3-3.png"
               alt="">
          <img src="../../assets/images/about-us/level-3-4.png"
               alt="">
          <img src="../../assets/images/about-us/level-3-5.png"
               alt="">
          <img src="../../assets/images/about-us/level-3-6.png"
               alt="">
        </div>
        <div>
          <div>公司核心技术团队对智慧旅游/文旅融合互联网业务有着深刻理解的复合型技术人才，主流产品基于组件技术的业务分层设计思想，为互联网＋智慧旅游应用带来了非常灵活的扩展性。</div>
          <div>
            <span class="rongyu">公司荣誉</span> </br> 广东股权交易中心“科创版”挂牌 企业【股权代码：880178】 </br> 并荣获“ 国家高新技术企业 ” </br>“ 科技创新小巨人企业 ”</br> “双软认证企业”</br> “重合同守信用企业”</br> “2018 年智慧城市大数据十佳技术创新奖” </br>“广东新型智慧旅游行业信息化示范产品” </br>“多项国家技术应用型专利及软件著作权证书” </br>“ IOS 9001质量管理体系认证企业” </br>“广东省景区行业协会副会长单位”</br> “广东省智慧旅游专业委员会主任单位”</br> “中国旅游景区协会理事单位” </br>“广东省江西龙南商会副会长单位” </br>“2020年度大数据最具成长价值企业”等。</div>

        </div>
      </div>
    </div>

    <div class="level-4">
      <p>营业范围及专长</p>
      <p></p>
      <p>互联网＋智慧旅游/智慧景区，一部手机游 APP/小程序/公众号、旅游大数据平台、3D 智能导游系统、电子售检票系统/商城分销系统、电子触摸屏系统、游客集散中心/游客服务中心/旅游驿站/全息投影科普展厅、全域全景旅游导览地图绘制、AI/VR/人工智能技术应用及配套互联网等服务。</p>
    </div>
    <div class="level-5">
      <div>
        <img src="../../assets/images/about-us/logo.png"
             alt="">
      </div>
      <p> 公司旗下【翼旅游®】品牌，主要服务于“全域智慧旅游”信息化建设，其中“互联网＋3D 智能导游云服务系统平台及一部手机游小程序/APP 服务平台”是以“互联网+智慧旅游”为核心理念研发而成的 文旅 云服务平台。以实时在线语音讲解、3D 导览和精准营销服务为切入点，服务于游前、游中、游后的智能导游/导航/导览/导购、GPS 实时定位、自动规划线路、精准营销、周边商家优惠劵推送、活动提醒、特产商城、语音主播、POI 热点搜索、旅游新媒体、游记攻略、票务预订等功能为一体的智慧旅游共享开放服务平台。目前是国内在该领域技术最为成熟的 3D 智能导览数据提供商，获得了多家国内知名的投资机构的青睐。
      </p>
    </div>

    <div class="level-6 margT80">
      <div> 公司经过近8年的发展，文旅业务覆盖全国1500+个公园/景区/乐园/度假区，累计服务80+家文旅单位，成功助力100+个景区完成“创A”辅导落地。并与中山大学、武汉大学、华南理工大学、广东财经大学、东华理工大学、桂林理工大学、桂林旅游学院和广西旅游科学研究所在人才和技术方面建立了良好的合作关系，为公司致力于数字文旅产业建设服务提供了强大支持。
      </div>
    </div>
    <div class="level-7">
      <div class="level-7-title">
        服务案例
      </div>
      <div class="level-7-item">
        <img src="../../assets/images/about-us/level-7-1.png"
             alt="">
        <div>
          <p>服务过的全域旅游项目客户（部分）</p>
          <p>
            <a class="aTag"
               target="_blank"
               href="http://wglj.gz.gov.cn/">广州市文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="https://www.zhanjiang.gov.cn/bmzz/zjswhgdlytyjzww/index.html">湛江市文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="http://www.zs.gov.cn/wglj/">中山市文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="http://www.chaozhou.gov.cn/czwgltj/gkmlpt/index">潮州市文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="http://zwgk.longmen.gov.cn/5014/lmList.shtml">龙门县文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="https://www.huadu.gov.cn/gzjg/qzfgzbm/qwhgdlytyj/zyzz/">花都区文广旅体局</a>、
            <a class="aTag"
               target="_blank"
               href="http://www.dg.gov.cn/liaobu/">东莞寮步旅游办</a>、
            <a class="aTag"
               target="_blank"
               href="https://www.gxota.com/">广西旅发科技有限公司（文化和旅游厅下属单位）</a>
            等等。
          </p>
        </div>
      </div>
      <div class="level-7-item">
        <div>
          <p>服务过的全域旅游项目客户（部分）</p>
          <p>北京故宫、宁夏沙坡头、广州白云山、佛山西樵山、韶关丹霞山、东部华侨城、锦绣中华、世界之窗、长隆旅游度假区、越秀公园、千年瑶寨、南昆山、郴州东江湖、浙江莫干溪谷、三亚槟榔谷、北海三娘湾、广安邓小平故里、桂林龙脊梯田等等；全国服务过的景区客户近 500 家。
          </p>
        </div>
        <img src="../../assets/images/about-us/level-7-2.png"
             alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {

    }
  }
}
</script>
<style  scoped>
.tab-container {
  height: 100%;
}
.paddT80B360 {
  padding: 0.8rem 3.6rem !important;
}
.level-1 {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 30px rgba(233, 233, 233, 1);
  opacity: 1;
  padding: 0.4rem;
  box-sizing: border-box;
  margin: auto;
}
.level-1 > p:nth-child(1) {
  font-size: 0.3rem;
  font-weight: bold;
  color: #4d4d4d;
  text-align: center;
}
.level-1 > p:nth-child(2) {
  width: 100px;
  height: 4px;
  background: rgba(92, 212, 202, 1);
  opacity: 1;
  margin: 10px auto;
}
.level-1 > p:nth-child(3),.level-1 > p:nth-child(4) {
  color: #4d4d4d;
  font-size: 0.16rem;
  line-height: 0.28rem;
  text-indent: 0.3rem;
}
.level-1 > img{
  width: 100%;
}
.level-2 {
  width: 12rem;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 0.2rem;
}
.level-2 > img {
  width: 5.9rem;
  height: 3.9rem;
}
.level-3 {
  width: 12rem;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 0.2rem;
}
.level-3 > div {
  width: 49%;
}
.level-3 > div:nth-child(1) {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.level-3 > div:nth-child(1) > img {
  width: 2.9rem;
  height: 1.9rem;
  margin-bottom: 0.1rem;
}
.level-3 > div:nth-child(2) > div:nth-child(1) {
  width: 100%;
  background: rgba(233, 233, 233, 1);
  opacity: 1;
  padding: 0.64rem 0.45rem;
  font-size: 0.16rem;
  line-height: 0.28rem;
  color: #4d4d4d;
}
.level-3 > div:nth-child(2) > div:nth-child(2) {
  width: 100%;
  text-align: center;
  font-size: 0.16rem;
  padding: 0.2rem 0.45rem 0;
  line-height: 0.28rem;
}
.level-4 {
  width: 100%;
  /* height: 3rem; */
  background-image: url("../../assets/images/about-us/level-4-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* margin-top: 0.8rem; */
  padding: 0.8rem 0;
  box-sizing: border-box;
}
.level-4 > p:nth-child(1) {
  font-size: 0.3rem;
  font-weight: bold;
  color: #4d4d4d;
  text-align: center;
}
.level-4 > p:nth-child(2) {
  width: 100px;
  height: 4px;
  background: rgba(92, 212, 202, 1);
  opacity: 1;
  margin: 10px auto;
}
.level-4 > p:nth-child(3) {
  width: 9rem;
  color: #4d4d4d;
  font-size: 0.16rem;
  line-height: 0.28rem;
  text-indent: 0.3rem;
  margin: auto;
}

.level-5 {
  width: 100%;
  /* height: 3rem; */
  background-image: url("../../assets/images/about-us/level-5-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* margin-top: 0.8rem; */
  padding: 0.8rem 2.38rem;
  box-sizing: border-box;
}
.level-5 > div {
  width: 6.22rem;
  margin: auto;
}
.level-5 > div > img {
  width: 100%;
}
.level-5 > p {
  width: 6.22rem;
  font-size: 0.16rem;
  line-height: 0.3rem;
  color: #4d4d4d;
  text-indent: 0.3rem;
  margin: 0.8rem auto 0;
}

.level-6 {
  width: 12rem;
  height: 6rem;
  background-image: url("../../assets/images/about-us/level-6-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin: auto;
  position: relative;
  border: 1px solid transparent;
}
.level-6 > div {
  width: 4rem;
  background: rgba(41, 51, 50, 0.5);
  padding: 0.4rem;
  color: #ffffff;
  font-size: 0.16rem;
  line-height: 0.28rem;
  /* margin: 2rem 0 0 7rem; */
  margin-top: 2rem;
  margin-left: 7rem;
  text-indent: 0.3rem;
}

.level-7 {
  width: 12rem;
  margin: auto;
  padding: 0.8rem 0;
}
.level-7 > div {
  display: flex;
}
.level-7-title {
  color: red;
  justify-content: center;
  font-size: 0.3rem;
}

.level-7-item > img {
  /* width: 6rem; */
  height: 3rem;
}
.level-7-item > div {
  padding: 0.5rem 0.4rem;
  background: #ffffff;
}
.level-7-item > div > p:nth-child(1) {
  color: #4d4d4d;
  font-size: 0.3rem;
  text-align: center;
}
.level-7-item > div > p:nth-child(2) {
  color: #4b4b4b;
  font-size: 0.16rem;
  line-height: 0.28rem;
  margin-top: 0.2rem;
  text-indent: 0.3rem;
}
.aTag {
  text-decoration: none;
  color: #4b4b4b;
}
.aTag:hover {
  text-decoration: underline;
  color: #5cd4ca;
}
.rongyu{
  color: red;
  font-size: 0.20rem;
}
</style>